<template>
  <van-dialog v-model="value" :show-cancel-button="false" confirmButtonText="知道了" confirmButtonColor="#0052D9">
    <div class="max-price">
      <span style='color: #333'>亲，万饰网每笔订单金额 <i style='color: #F53F3F'>不能超过5w</i> 哦~</span><br>
      <span style="color: #595959;">你可以：</span>
      <span style='color: #333;font-weight: bold;'>1、分多次下单</span>
      <span style='color: #333;font-weight: bold;'>2、每笔订单金额 <i style='color: #F53F3F'> &lt;5w </i></span>
    </div>
  </van-dialog>
</template>

<script>

export default {
  props: {
    value: [Boolean],
  },
  data() {
    return {
      show: false,
    }
  },
  watch: {
    value(val){
      this.show = val;
    },
    show(val){
      this.$emit('input', val)
    }
  },
  created() {
  },
  components: {

  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped lang="less">
.max-price {
  padding: 64px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;

  >span {
    text-align: center;
    line-height: 48px;
  }
}
</style>
